const APP_ROUTES = {
  // Public Routes
  HOME: "/",
  LOGIN: "/login",

  // Dashboard
  DASHBOARD: "/dashboard",

  // Network
  NETWORK: "/network",

  // Explore
  EXPLORE: "/explore",

  // Entity Management
  ENTITY: "/entity",
  CREATE_GROUP: "/entity/create-group",
  GROUP_DETAILS: "/entity/group/:groupId",
  ENTITY_DETAILS: "/entity/:entityId",
  ENTITY_ACHIEVEMENTS: "/entity/:entityId/achievements/:achievementId",
  ENTITY_GROUP_CREATE: "/entity/:entityId/groups/create",
  ENTITY_GROUP_DETAILS: "/entity/:entityId/groups/:groupId",
  ENTITY_PROFILE_EDIT: "/entity/:entityId/edit",
  ENTITY_PROFILE_EDIT_BRANCH: "/entity/:entityId/edit/branch/:branchId",
  ENTITY_PROFILE_BRANCH: "/entity/:entityId/branch/:branchId",
  ALL_SERVICES: "/:persona/:id/all-services",
  ALL_REVIEWS: "/:persona/:id/all-reviews",

  // Profiles
  PLAYER: "/player/:userId",
  PLAYER_TROPHIES: "/player/:userId/trophies",
  COACH: "/coach/:userId",
  AGENT: "/agent/:userId",
  SCOUT: "/scout/:userId",
  OTHER_PROFILE: "/other/:userId",
  PERSONA_TESTIMONIALS: "/:persona/:userId/testimonials",

  // Go Hire
  GO_HIRE: "/go-hire",
  JOBS: "/go-hire/jobs",
  CREATE_JOB: "/go-hire/create-job",
  JOB_OVERVIEW: "/go-hire/jobs/:jobId",
  CANDIDATE_DETAILS: "/go-hire/jobs/:jobId/candidates/:candidateId",
  CANDIDATE_GINO_FIT_SCORE: "/go-hire/jobs/:jobId/candidates/:candidateId/gino-fit-score",
  CANDIDATE_REPORT: "/go-hire/jobs/:jobId/candidates/:candidateId/review/:reviewId",

  // Go Service
  OVERVIEW_SERVICES: "/go-hire/overview-services",
  MY_SERVICES: "/go-hire/my-services",
  SERVICE_PAGE: "/go-hire/service/:serviceId",
  PROGRAM_PAGE: "/go-hire/program/:serviceId",
  PROGRAM_VIDEO_PAGE: "/go-hire/program/:serviceId/video/:videoId",
  SERVICE_REVIEW_PAGE: "/go-hire/service/:serviceId/reviews",
  SERVICE_REQUEST_PAGE: "/go-hire/service-request/:serviceRequestId",
  REQUEST_PAGE: "/go-hire/request/:serviceRequestId",
  PROGRAM_REQUEST_PAGE: "/go-hire/program-request/:programRequestId",
  TRENDING_SERVICES: "/go-hire/trending-services",
  TRENDING_PROVIDERS: "/go-hire/trending-providers",
  CREATE_CONTRACT: "/go-hire/create-contract/:requestId/:serviceId",
  CREATE_SERVICE: "/go-hire/create-service",

  // Go Star
  GO_STAR: "/explore/go-star",
  GO_STAR_QUERY: "/explore/go-star/:query",

  // Search
  SEARCH: "/search",

  // Chat
  CHAT: "/chat",
  CHAT_DETAILS: "/chat/:chatId/:sendToID",
  CHAT_REVAMP: "/chat-revamp/:chatId/:sendToID",
  CHAT_REVAMP_DETAILS: "/chat-revamp",

  // Events
  EVENTS: "/explore/events",
  CREATE_EVENT: "/explore/events/create",
  CREATE_EVENT_STEPS: "/explore/events/create/:eventType",
  EVENT_CREATED: "/explore/events/create/success",
  EVENT_DETAILS: "/explore/events/:eventId",
  INVITE_PARTICIPANTS: "/explore/events/:eventId/invite",

  // Not Found
  NOT_FOUND: "/404/",
  CATCH: "*",

  // Network Error
  NETWORK_ERROR: "network-error",

  // Payment
  PAYMENT: "/payment",
  PAYMENT_HOW_IT_WORKS: "/payment/how-it-works",
  PAYMENT_LINKS: "/payment/payment-links",
  CREATE_PAYMENT_LINK: "/payment/create-payment-link",
  CREATE_PAYMENT_ACCOUNT: "/payment/create-payment-account",

  // Payment link
  PAYMENT_LINK: "/payment-link/:linkId",
  PAYMENT_LINK_SUCCEED: "/payment-succeed/",
  PAYMENT_LINK_FAILED: "/payment-failed/",

  // Feed
  FEED: "/feed",
  CREATE_POST: "/feed/create-post",
  EDIT_POST: "/feed/edit-post/:postId",

  // GINO
  GINO: "/gino",
  GINO_CHAT: "/gino/chat",
  GINO_SEARCH_RESULTS: "/gino/search-results/",
  GINO_CHAT_HISTORY: "/gino/chat-history/",
  GINO_CHAT_HISTORY_ROOM: "/gino/chat-history/:chatId",

  // Settings
  SETTINGS: "/settings",
  PLANS: "/settings/plans",
  PLANS_OVERVIEW: "/settings/plans/overview",

  // Public
  PUBLIC_HOME: "/public/home",
};

export default APP_ROUTES;
